import styles from "./TimelinePhoto.module.scss";
import placerholderIcon from "../../assets/mountains.svg";
import React from "react";

export function PlaceholderView({ showPhotoUploadModal }) {
    return (
        <div
            className={`is-relative ${styles.photoContainer} ${styles.isPlaceholder}`}
        >
            <div>
                <div>
                    <div
                        onClick={() => showPhotoUploadModal()}
                        className={`${styles.photo}`}
                        style={{
                            backgroundImage: `url(${placerholderIcon})`,
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
}
